module.exports = __webpack_public_path__ + "img/6.2d36e259.png";